<template>
    <div class="bottom-sheet-button__wrapper">
        <div>
            <span>{{ label }}:&nbsp;</span>
            <span class="bottom-sheet-button__value">{{ value }}</span>
        </div>
        <VJoyIcon v-if="open" :name="'chevron-down'" size="xsmall" color="neutral" />
        <VJoyIcon v-else :name="'chevron-up'" size="xsmall" color="neutral" />
    </div>
</template>

<script setup lang="ts">
    import {VJoyIcon} from '@maltjoy/core-vue';

    withDefaults(
        defineProps<{
            label?: string;
            value?: string;
            open?: boolean;
        }>(),
        {
            open: false,
        },
    );
</script>

<style lang="scss" scoped>
    .bottom-sheet-button {
        &__wrapper {
            display: flex;
            justify-content: space-between;
            font-size: var(--joy-font-size-primary-300);
            line-height: var(--joy-line-height-large);
            padding: var(--joy-core-spacing-3);
            background-color: var(--joy-color-secondary-10);
            border-radius: var(--joy-core-radius-2);
            color: var(--joy-color-secondary-50);
            font-weight: var(--joy-font-weight-bold);

            &:hover {
                cursor: pointer;
            }
        }

        &__value {
            font-size: var(--joy-font-size-primary-400);
        }
    }
</style>
